<!--<div [ngClass]="cssClass">-->
  <!--<section>-->
    <router-outlet></router-outlet>
    <!--<ribbon></ribbon>
  </section>-->
  <!--<global-modal></global-modal>-->
  <loading-modal></loading-modal>
<!--</div>-->
